import { Box } from '@factorialco/deprecated-design-system'
import { AtsTemplatesSettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useAtsContext } from 'modules/ats/lib/atsContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EvaluationForms } from './sections/EvaluationForms'
import { MessageTemplates } from './sections/MessageTemplates'
import { QuestionTemplates } from './sections/QuestionTemplates'

const TemplatesPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(AtsTemplatesSettingsPageDocument)
  const { canManageAtsSettings } = useAtsContext()

  const featureAvailable = (id: string) => {
    return data?.companies.featureAvailabilitiesConnection.nodes.find((node) => node.id === id)
      ?.available
  }

  const showQuestionTemplates = featureAvailable('ats_customized_features')
  const showMessageTemplates = featureAvailable('ats_message_templates')
  const showEvaluationForms = canManageAtsSettings && featureAvailable('ats_evaluation_forms')

  return (
    <ResponsivePage.Body
      error={null}
      loading={loading}
      showHeader={false}
      authorized={showQuestionTemplates || showMessageTemplates || showEvaluationForms}
    >
      <Box gap="s48">
        {showQuestionTemplates && <QuestionTemplates companyId={company.id} />}
        {showMessageTemplates && <MessageTemplates />}
        {showEvaluationForms && <EvaluationForms />}
      </Box>
    </ResponsivePage.Body>
  )
}

export default TemplatesPage
